import { addTouchDeviceClass } from './helpers/utilify';
// import GNav from './modules/app-global-navigation';
import ClickToScrollIntoView from './modules/click-to-scroll-into-view';
import toggleClassOnScroll from './modules/toggle-class-on-scroll';
// import Swiper, { Lazy, Autoplay, A11y, Pagination, Navigation } from 'swiper';
// import ScrollOut from 'scroll-out';

// https://swiperjs.com/
// Swiper.use([Lazy, Autoplay, A11y, Pagination, Navigation]);

addTouchDeviceClass();

/**
 * @param {HTMLElement} trigger
 * @returns {void}
 */
function toggleAriaExpanded(trigger) {
  const expanded = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', !expanded);
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    // ScrollOut({
    //   once: true,
    //   threshold: 0.3,
    // });

    // /**
    //  * グローバルナビゲーション
    //  */
    // GNav.init({
    //   gnavSelector: '#gnav',
    //   triggerSelector: '#gnav-trigger',
    //   largeMediaQuery: '(min-width: 992px)',
    //   currentBar: '#gnav-current-bar',
    // });

    /**
     * TOPアコーディオン
     */
    const topAccordions = document.querySelectorAll(
      '#top-content a[aria-expanded]'
    );
    if (topAccordions.length) {
      for (let i = 0, len = topAccordions.length; i < len; ++i) {
        topAccordions[i].addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            toggleAriaExpanded(e.currentTarget);
          },
          false
        );
      }
    }

    /**
     * 検索バー表示
     */
    const searchTrigger = document.querySelector('#header-search-form-trigger');
    if (searchTrigger) {
      searchTrigger.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          const trigger = e.currentTarget;
          toggleAriaExpanded(trigger);
          const target = trigger.nextElementSibling;
          const input = target ? target.querySelector('input') : null;
          if (input) input.focus();
        },
        false
      );
    }

    /**
     * アンカーリンク
     */
    const headerHeight = 72; // 厳密でない。MAX値
    // eslint-disable-next-line no-new
    new ClickToScrollIntoView('.js-anchor-link', {
      offsetY: headerHeight,
    });

    /**
     * For Easy Table of Contents Plugin
     * @see https://ja.wordpress.org/plugins/easy-table-of-contents/
     */
    // eslint-disable-next-line no-new
    new ClickToScrollIntoView('.ez-toc-link', {
      offsetY: headerHeight,
    });

    /**
     * スクロールトップ
     */
    toggleClassOnScroll(document.querySelector('#scroll-top'));
  },
  false
);

window.addEventListener(
  'load',
  () => document.body.classList.add('is-loaded'),
  false
);
